import PropTypes from 'prop-types';
import React, {Component} from 'react';

import deepEqual from 'lodash/isEqual';


import events from 'lib/events.js';
import Loader from 'components/loader.jsx';
import Button from 'components/layout/Button';
import Col from 'components/Col';

import PastDuePrintReport from './print';
import PastDueReportFilters from './filters';
import PastDueReportResults from './results';

import {formatReport} from './helpers';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

import ReportApi from 'api/report.jsx';

class PastDueWaterAnalysisReport extends Component {
  static propTypes = {
    branches: PropTypes.any,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    branches: [],
  };

  static propTypes = {
    branches: PropTypes.any,
  };

  state = {
    loaded: true,
    summary: null,
    report: null,
    page: 1,
    count: 20,
    total: 0,
    showNoDataMessage: false,
    activeFilters: {},
  };

  fetchData = (getSummary = true) => {
    let {page, count} = this.state;
    const activeFilters = this.filters.value;
    const {start, end, poolType, branch} = activeFilters;

    const branches = this.props.branches.map(x => x.id);

    if (!deepEqual(this.state.activeFilters, activeFilters)) {
      page = 1;
    }

    let nextState = {loaded: false};

    if (getSummary) {
      nextState.summary = null;
    }

    this.setState(nextState);

    let apis = [];

    apis.push(ReportApi.getPastDueReport(
      branch === -1 ? branches : branch,
      start.format(),
      end.format(),
      poolType === -1 ? null : poolType,
      page,
      count));


    if (getSummary) {
      apis.push(ReportApi.getPastDueReportSummary(
        branch === -1 ? branches : branch,
        start.format(),
        end.format(),
        poolType === -1 ? null : poolType));
    }

    Promise.all(apis)
    .then(([reportData, summary]) => {
      reportData = reportData || {};
      reportData.report = formatReport(reportData.report, this.getLabel);

      if (summary && summary.totalAccounts > 0 || !getSummary) {
        summary = summary || this.state.summary;

        this.setState({
          activeFilters,
          summary,
          page,
          report: reportData.report,
          total: summary.total,
          showNoDataMessage: false,
        });
      } else {
        this.setState({showNoDataMessage: true});
      }
      this.setState({loaded: true});

    }).catch(err => {
      console.log(err);
      this.setState({loaded: true,showNoDataMessage: true});
    });
  };

  printReport = () => {
    const {summary, activeFilters} = this.state;

    ReportApi.getPastDueReport(
        activeFilters.branch === -1 ? this.props.branches.map(x => x.id) : activeFilters.branch,
        activeFilters.start.format(),
        activeFilters.end.format(),
        activeFilters.poolType === -1 ? null : activeFilters.poolType,
        null,
        null)
      .then(reportData => {
        reportData = reportData || {};
        reportData.report = formatReport(reportData.report, this.getLabel);

        events.publish('print',
          <PastDuePrintReport start={activeFilters.start}
                              end={activeFilters.end}
                              report={reportData.report}
                              summary={summary}
                              formatMessage={this.getLabel} />);
      });
  };

  exportReport = () => {
    const {start, end, branch, poolType} = this.filters.value;

    return ReportApi.getPastDueReportExport(
      this.props.intl.locale,
      branch === -1 ? this.props.branches.map(x => x.id) : branch,
      start.format(),
      end.format(),
      poolType === -1 ? null : poolType);
  };

  getLabel = id => this.props.intl.formatMessage({id: id});

  onPageChange = page => this.setState({page}, () => this.fetchData(false));

  render() {
    const {summary, loaded, report, count, total, page, showNoDataMessage, activeFilters} = this.state;

    return <div className='report-container past-due-report'>
      <div className='description'>
        <FormattedMessage id="reports.pastdue.description" />
      </div>
      <div className='report-options'>
        <div className='top-title-bar'><FormattedMessage id="general.report.options" /></div>
        <PastDueReportFilters ref={r => this.filters = r} branches={this.props.branches} formatMessage={this.getLabel} />
        <div className='manage-options'>
          <div className='col-sm-12 button-group'>
            <span className='reset-button pull-right' onClick={() => this.filters.reset()}><FormattedMessage id="general.reset" /></span>
            <Button primary className='pull-right' onClick={() => this.fetchData(true)}><FormattedMessage id="reports.update.summary" /></Button>
          </div>
        </div>
      </div>
      <Loader loaded={loaded}>
        <PastDueReportResults summary={summary}
                              page={page}
                              activeFilters={activeFilters}
                              count={count}
                              report={report}
                              showNoDataMessage={showNoDataMessage}
                              total={total}
                              onPageChange={this.onPageChange}
                              formatMessage={this.getLabel} />
      </Loader>
      <Col sm={12} className='button-group shift-right'>
        <Button default
                className='pull-right'
                disabled={summary === null}
                onClick={this.printReport}>
          <FormattedMessage id="reports.print.summary" />
        </Button>
        <Button primary
                className='pull-right'
                onClick={this.exportReport}><FormattedMessage id="reports.export.report" /></Button>
      </Col>
    </div>;
  }
}

export default injectIntl(PastDueWaterAnalysisReport);
